// extracted by mini-css-extract-plugin
module.exports = {"message":"DbUpdateWarning_message__2weSL"};